import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { useStreaming } from './hooks/useStreaming';
import Grid from './components/Grid';
import Controls from './components/Controls';
import Presets from './components/Presets';
import ConfigPanel from './components/ConfigPanel';
import Navigation from './components/Navigation';
import TuringMachineDocs from './pages/TuringMachineDocs';
import TuringMachineDocsDetailed from './pages/TuringMachineDocsDetailed';
import TuringMachineCalculator from './pages/TuringMachineCalculator';
import Research from './pages/Research';
import UltraDeepFusion from './pages/UltraDeepFusion';

function Visualizer() {
  const {
    grid,
    currentGeneration,
    isStreaming,
    status,
    categories,
    filteredPresets,
    selectedPreset,
    selectedCategory,
    gridSize,
    maxGenerations,
    streamInterval,
    initializerType,
    density,
    seedValue,
    gridScale,
    isLoadingPresets,
    presetsError,
    startStream,
    stopStream,
    resetGrid,
    getCellColor,
    setSelectedCategory,
    setSelectedPreset,
    updateConfig
  } = useStreaming() as any;

  return (
    <>
      <header className="App-header">
        <h1>Symmetric Cellular Automata & Turing Machine</h1>
        <p>Real-time Cellular Automata Visualization</p>
      </header>

      <main className="main-content">
        <Presets
          categories={categories}
          selectedCategory={selectedCategory}
          filteredPresets={filteredPresets}
          selectedPreset={selectedPreset}
          setSelectedCategory={setSelectedCategory}
          setSelectedPreset={setSelectedPreset}
          isLoading={isLoadingPresets}
          error={presetsError}
        />

        <div className="content-wrapper">
          <div className="left-panel">
            <ConfigPanel
              gridSize={gridSize}
              maxGenerations={maxGenerations}
              streamInterval={streamInterval}
              initializerType={initializerType}
              density={density}
              seedValue={seedValue}
              gridScale={gridScale}
              updateConfig={updateConfig}
            />
          </div>

          <div className="center-panel">
            <Controls
              isStreaming={isStreaming}
              status={status}
              currentGeneration={currentGeneration}
              maxGenerations={maxGenerations}
              startStream={startStream}
              stopStream={stopStream}
              resetGrid={resetGrid}
            />

            <Grid
              grid={grid}
              getCellColor={getCellColor}
              gridScale={gridScale}
            />
          </div>
        </div>
      </main>
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<Visualizer />} />
          <Route path="/turing-machine" element={<TuringMachineDocs />} />
          <Route path="/turing-machine/detailed" element={<TuringMachineDocsDetailed />} />
          <Route path="/calculator" element={<TuringMachineCalculator />} />
          <Route path="/research" element={<Research />} />
          <Route path="/ultra-deep-fusion" element={<UltraDeepFusion />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
